(function () {
  let debounceTimer;

  function parseMoneyCents(el) {
    let text = el ? el.textContent.replace(/[^0-9.]/g, '') : '';
    return Math.round(parseFloat(text) * 100) || 0;
  }

  function formatSavings(cents) {
    let dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  let observedRoots = new WeakSet();

  function queryShadowAll(root, selector) {
    let results = [];
    try {
      root.querySelectorAll(selector).forEach(function (el) { results.push(el); });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          observeShadowRoot(el.shadowRoot);
          queryShadowAll(el.shadowRoot, selector).forEach(function (r) { results.push(r); });
        }
      });
    } catch (e) {}
    return results;
  }

  function updateSavingsCallouts() {
    let containers = queryShadowAll(document.body, '.text-right.whitespace-nowrap');
    containers.forEach(function (container) {
      let originalEl = container.querySelector('[part="money"]:not([part~="discount"])');
      let discountEl = container.querySelector('[part~="discount"]');
      let savingEl = container.querySelector('.text-xs.text-right');

      if (!originalEl || !discountEl || !savingEl) return;

      let savedCents = parseMoneyCents(originalEl) - parseMoneyCents(discountEl);
      if (savedCents > 0) {
        let next = 'Saving ' + formatSavings(savedCents);
        if (savingEl.textContent !== next) savingEl.textContent = next;
      }
    });
  }

  function scheduleUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateSavingsCallouts, 200);
  }

  function observeShadowRoot(root) {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    let obs = new MutationObserver(scheduleUpdate);
    obs.observe(root, { childList: true, subtree: true });
  }

  let observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, { childList: true, subtree: true });
})();
